<app-toolbar-seller [name]="parameters"></app-toolbar-seller>

<app-manage-seller></app-manage-seller>